import React, { useEffect, useState } from "react";
import axios from "axios";
import { getSliders } from "../Service/Api";

const HomeSlider = () => {
  const [dynamicSlide, setDynamicSlider] = useState([]);

  useEffect(() => {
    async function getSlider() {
      try {
        const response = await axios.get(getSliders());

        console.log("API RESPONSE:", response.data);

        const sliderList = Array.isArray(response.data)
          ? response.data
          : response.data.data;

        setDynamicSlider(sliderList);
      } catch (error) {
        console.error("API isn't responding", error);
      }
    }
    getSlider();
  }, []);

  const IMAGE_BASE_URL = "https://webapi.entab.info/api/image";

  return (
    <div
      id="carouselExampleControls"
      className="carousel slide"
      data-bs-ride="carousel">
      <div className="carousel-inner">
        {dynamicSlide?.length > 0 ? (
          dynamicSlide.map((slide, index) => {
            const imageUrl = `${IMAGE_BASE_URL}/${slide.attachment}`;

            return (
              <div
                key={slide._id}
                className={`carousel-item ${index === 0 ? "active" : ""}`}>
                <img
                  src={imageUrl}
                  className="d-block w-100"
                  alt={slide.title || "slider-img"}
                />
              </div>
            );
          })
        ) : (
          <div className="carousel-item active">
            <img
              src="https://webapi.entab.info/api/image/JRPSB/Sliders/076de8fabafa0a5bc6923065cabf0388"
              className="d-block w-100"
              alt="fallback"
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default HomeSlider;
